import { ReactNode } from 'react';
import { permissions } from '@axo/shared/data-access/types';
import { useHasAnyOfRoles } from '@axo/shared/data-access/provider';

export type IRestricted = {
  isAllowedFor: permissions.RoleName[];
  children: ReactNode;
  fallback?: ReactNode;
};

// This component is meant to be used everywhere a restriction based on user permission is needed
export function Restricted({ isAllowedFor, children, fallback }: IRestricted) {
  // Get the user's roles from the DataAccessContext, using the hook.
  const hasRole = useHasAnyOfRoles(isAllowedFor);

  // If the user has that permission, render the children
  if (hasRole) {
    return <>{children}</>;
  }

  // Otherwise, do not render anything
  return fallback ? <>{fallback}</> : null;
}
